import React, { useEffect } from 'react'
import { TopicSection, Container, CardSection } from './Stlyed'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import Typography from '@mui/material/Typography'
import { fetchData } from './events'
import CardLocation from './CardLocation'
import { fileUrl } from 'src/utils/lib'

const BodyLocation = () => {
  const dispatch = useDispatch()
  const data = useSelector((state) => state.location.data, shallowEqual)
  useEffect(() => {
    dispatch(fetchData())
  }, [])
  const titleInformation = _.get(data, 'titleInformation', {})
  const stationList = _.get(data, 'stationInformation', [])
  const subtitle = _.get(titleInformation, 'subtitle', '')
  const title = _.get(titleInformation, 'title', '')
  const noTitle = _.isEmpty(title) && _.isEmpty(subtitle)

  return (
    <Container>
      <TopicSection pb={noTitle ? 0 : 6}>
        <Typography
          variant="h6"
          sx={{ typography: { sm: 'h5', lg: 'h5' } }}
          color="primary"
        >
          {subtitle}
        </Typography>
        <Typography
          variant="h5"
          sx={{ typography: { sm: 'h4', lg: 'h3' } }}
          color="primary"
        >
          {title}
        </Typography>
      </TopicSection>
      <CardSection>
        {stationList.map((item, itemIndex) => {
          const image = fileUrl(item.img)
          const imageMap = fileUrl(item.imgMap)
          return (
            <CardLocation
              key={itemIndex}
              image={image}
              imageMap={imageMap}
              item={item}
            />
          )
        })}
      </CardSection>
    </Container>
  )
}

export default BodyLocation
